module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "id": "services"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12 text-center"
  }, [_c('h2', {
    staticClass: "section-heading"
  }, [_vm._v("Features")]), _vm._v(" "), _c('h3', {
    staticClass: "section-subheading text-muted"
  }, [_vm._v("With Netsix, sharing videos with your friends is fast and simple."), _c('br'), _vm._v("\n          Once connected in peer-to-peer, you can stream and watch videos stored on a friend's hard drive as fast as possible."), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://github.com/mmorainville/netsix/releases/latest",
      "target": "_blank"
    }
  }, [_vm._v("Download Netsix")]), _vm._v(".")])])]), _vm._v(" "), _c('div', {
    staticClass: "row text-center"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('span', {
    staticClass: "fa-stack fa-4x"
  }, [_c('i', {
    staticClass: "fa fa-circle fa-stack-2x text-primary"
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-fighter-jet fa-stack-1x fa-inverse"
  })]), _vm._v(" "), _c('h4', {
    staticClass: "service-heading"
  }, [_vm._v("Fast")]), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("Netsix uses WebRTC to create a real peer-to-peer connection.")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('span', {
    staticClass: "fa-stack fa-4x"
  }, [_c('i', {
    staticClass: "fa fa-circle fa-stack-2x text-primary"
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-laptop fa-stack-1x fa-inverse"
  })]), _vm._v(" "), _c('h4', {
    staticClass: "service-heading"
  }, [_vm._v("Simple")]), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("Installing and using Netsix is really simple: just download the app and share your ID.")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('span', {
    staticClass: "fa-stack fa-4x"
  }, [_c('i', {
    staticClass: "fa fa-circle fa-stack-2x text-primary"
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-lock fa-stack-1x fa-inverse"
  })]), _vm._v(" "), _c('h4', {
    staticClass: "service-heading"
  }, [_vm._v("Secure")]), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("The WebRTC connexion is naturally encrypted and no one can see what you are sharing with your friends.")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('span', {
    staticClass: "fa-stack fa-4x"
  }, [_c('i', {
    staticClass: "fa fa-circle fa-stack-2x text-primary"
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-rebel fa-stack-1x fa-inverse"
  })]), _vm._v(" "), _c('h4', {
    staticClass: "service-heading"
  }, [_vm._v("Open Source")]), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("The code is on "), _c('a', {
    attrs: {
      "href": "https://github.com/mmorainville/netsix",
      "target": "_blank"
    }
  }, [_vm._v("GitHub")]), _vm._v(" and you are free to help improve the app.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-47b2a25d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Services.vue
// module id = 114
// module chunks = 1